import styled, { css } from 'styled-components'
import {backgroundOrange, darkOrange, orange, gold, danger, dangerTint, black, textMuted, mutedGrey, border1, border2, scrimDark} from '@/theme/colors'
import { radii, layers } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { Input } from '@components/Field'

/** The shared form kit (Field + Button primitives) — one copy for every modal. */
export { Button, ButtonGroup, FormGroup, FormInput, FormLabel } from '@pages/Itinerary/AddEventModal/FormComponents.styles'

export const AmountInputWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
`

export const AmountPrefix = styled.span`
	position: absolute;
	left: 16px;
	font-size: ${fontSizes.body};
	color: ${textMuted};
	pointer-events: none;
`

export const AmountInput = styled(Input)`
	padding-left: 32px;
	-moz-appearance: textfield;

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`

export const StepIndicator = styled.div`
	${text.eyebrow}
	color: ${gold};
	margin-bottom: 20px;
`

export const StepHeading = styled.h3`
	${text.title}
	color: ${darkOrange};
	margin: 0 0 20px 0;
`

export const BackButton = styled(Button).attrs({ variant: 'ghost' as const, size: 'sm' as const })`
	padding-left: 0;
	margin-bottom: 16px;
`

export const MemberList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`


export const MemberName = styled.span`
	font-size: ${fontSizes.base};
	font-weight: 500;
	color: ${black};
	flex: 1;
`

export const PayerRecipientRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
	padding: 20px;
	background: ${backgroundOrange};
	border-radius: ${radii.inner};
	margin-bottom: 24px;
`

export const PayerRecipientPerson = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
`

export const PayerRecipientLabel = styled.span`
	${text.eyebrow}
	color: ${textMuted};
`

export const PayerRecipientName = styled.span`
	font-size: ${fontSizes.small};
	font-weight: 500;
	color: ${black};
`

export const PayerRecipientArrow = styled.div`
	color: ${darkOrange};
	font-size: ${fontSizes.headingLg};
	font-weight: 700;
`

export const ImageSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const ImagePreview = styled.div`
	width: 120px;
	height: 120px;
	border-radius: ${radii.small};
	overflow: hidden;
	cursor: pointer;
	border: 1px solid ${border1};

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const ImagePlaceholder = styled.label`
	width: 120px;
	height: 120px;
	border-radius: ${radii.small};
	border: 2px dashed ${border2};
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	color: ${mutedGrey};

	svg {
		width: 32px;
		height: 32px;
	}

	&:hover {
		border-color: ${orange};
		color: ${orange};
	}
`

export const ImageActions = styled.div`
	display: flex;
	gap: 8px;
`

export const ImageActionButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'sm' as const })<{ $danger?: boolean }>`
	${({ $danger }) =>
		$danger &&
		css`
			color: ${danger};
			border-color: ${danger}40;

			&:hover:not(:disabled) {
				background: ${dangerTint};
				color: ${danger};
				border-color: ${danger};
			}
		`}
`

export const ImageOverlay = styled.div`
	position: fixed;
	inset: 0;
	background: ${scrimDark};
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: ${layers.viewer};
	cursor: pointer;

	img {
		max-width: 90%;
		max-height: 90%;
		object-fit: contain;
	}
`

export const ValidationError = styled.div`
	font-size: ${fontSizes.caption};
	color: ${danger};
	margin-top: 6px;
`

export const SoftWarning = styled.div`
	font-size: ${fontSizes.caption};
	color: ${gold};
	background: ${gold}1f;
	padding: 8px 12px;
	border-radius: ${radii.small};
	margin-top: 8px;
`

export const ThirdPartyNotice = styled.div`
	font-size: ${fontSizes.micro};
	text-align: center;
	font-style: italic;
	margin-top: 16px;
	line-height: ${leading.body};
`
